module.exports = __webpack_public_path__ + "assets/img/commission4.0c46c36b.svg";